import ArkLoader from '@src/js/common/ark-extensions';
import InactivityGuideService from '@src/slide/application/service/inactivity-guide/core/inactivity-guide-service-base';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { openUrlForAll } from '@src/slide/infrastructure/module/independent/url/open-url';
import Snackbar from '@tencent/dui/lib/components/Snackbar';

export default class InactivityGuideServicePc extends InactivityGuideService {
    protected showSnackbar(
        content: string,
        btnActionType: string,
        btnAction?: string,
        btnText?: string,
        duration?: number,
        reportOnClick?: {
            [key: string]: string;
        },
    ) {
        const snackbar = Snackbar.show({
            message: content,
            duration,
            action: btnText,
            onClickAction: () => {
                if (btnActionType) {
                    this.handleBtnActionType(btnActionType);
                } else if (btnAction) {
                    // 没有 btnActionType 字段，走后端逻辑，点击跳转 btnAction 的链接
                    openUrlForAll({ url: btnAction });
                }

                if (reportOnClick) {
                    tdw({
                        ...reportOnClick,
                        ver5: content,
                        ver6: btnActionType,
                    });
                }
                snackbar?.close();
            },
        });
    }

    protected handleToPdf = () => {
        this.services.menuManager?.exportPDF();
    };

    protected handleCollect = async () => {
        const { padId, domainId } = window.clientVars;

        const collectStatus = await ArkLoader.extensionService.dependentServiceCombinder?.fileDomain
            .getDocCollect({
                domainId,
                padId,
            });
        // 已收藏的不管
        if (collectStatus?.resData?.data?.isCollected) {
            return;
        }

        // pc的需要找下dom
        const collectBtn = document.querySelector('#workbench-titlebar #badge-container .editor-badge-icon-star');
        if (!collectBtn) {
            return;
        }
        (collectBtn as HTMLElement)?.click?.();
    };
}
